<template lang="pug">
.form-group
    label.label-title {{ label }}
    textarea.form-control(rows="3", v-bind:value="value", @input="$emit('input', $event.target.value)")
    small.form-text
        span.text-muted.pr-2(v-if="description") {{ description }}
        span(:class="charLimit ? 'text-danger' : 'text-muted'") {{ charCounter }} von {{ charlimit }} Zeichen
</template>

<script>
export default {
    props: {
        value: {
            type: String,
            default: ''
        },
        label: {
            type: String,
            default: 'Ihre Anmerkungen'
        },
        charlimit: {
            type: Number,
            default: 160
        },
        description: {
            type: String,
            default: ''
        }
    },
    computed: {
        charCounter () {
            return this.value ? this.value.length : 0
        },
        charLimit () {
            if (!this.value) return false
            return this.value.length > this.charlimit
        }
    }
}
</script>

<style lang="scss" scoped>
textarea {
    resize: none;
}
</style>
